/* eslint max-len: ["error", 250] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import GoogleLogin from 'react-google-login'
import constant from '../../../constants'
import googleImg from '../../../../media/google.svg'

export default class Google extends Component {
  responseGoogle = (response) => {
    this.props.onLoginResponse(response)
  }

  render() {
    return (
      <GoogleLogin
        clientId={constant.GOOGLE_CLIENT_ID}
        onSuccess={this.responseGoogle}
        onFailure={(error) => {}}
        className="join-with gg cursor-pointer xs-block xs-relative"
        offline={false}
        prompt="consent"
      >
        <span className="join-text">{this.props.buttonText}</span>
        <img alt='Google' src={googleImg} />
      </GoogleLogin>
    )
  }
}

Google.propTypes = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}

Google.defaultProps = {
  onLoginResponse: PropTypes.func,
  buttonText: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/social/google/google.js